import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { PollingNewsletterRequest } from './polling-newsletter.request';
import { PollingNewsletterResponse } from './polling-newsletter.response';

@Injectable({ providedIn: 'root' })
export class PollNewsletterUseCase extends UseCase<PollingNewsletterRequest, Observable<PollingNewsletterResponse>> {
    private _apiRequestService = inject(ApiRequestService);
    private _emailBaseUrl = inject<string>('EMAIL_BACKEND_URL' as any);
    private _pollingNewsletterUrl = '/admin/pollingNewsletter';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(
        request: PollingNewsletterRequest | void
    ): Observable<PollingNewsletterResponse> | void {
        return this._apiRequestService.sendRequest<PollingNewsletterRequest, PollingNewsletterResponse>(
            this._emailBaseUrl,
            request as PollingNewsletterRequest,
            true,
            this._pollingNewsletterUrl
        );
    }
}
